export const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  const mobileKeywords = ['android', 'iphone', 'ipod', 'ipad', 'windows phone', 'mobile']
  return mobileKeywords.some(keyword => userAgent.includes(keyword))
}

export const isDesktop = () => {
  return !isMobile()
}

// 获取设备类型
export const getDeviceType = () => {
  return isMobile() ? 'mobile' : 'desktop'
} 